module.exports = __webpack_public_path__ + "static/media/v1.5389ba42.png";